(() => {
  const initialize = (section) => {
    if (section.dataset.enhanced === 'true') return;
    const track = section.querySelector('[data-gallery-track]');
    const slides = Array.from(section.querySelectorAll('[data-media-id]'));
    const thumbnails = Array.from(section.querySelectorAll('[data-media-target]'));
    let activeIndex = 0;
    const setActiveMedia = (index, scroll = true) => {
      if (!track || !slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      thumbnails.forEach((thumbnail, position) => {
        thumbnail.classList.toggle('is-active', position === activeIndex);
        if (position === activeIndex) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
      if (scroll) track.scrollTo({ left: activeIndex * track.clientWidth, behavior: 'instant' });
      slides.forEach((slide, position) => {
        if (position !== activeIndex) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    };
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', (event) => {
      event.preventDefault();
      setActiveMedia(index);
    }));
    section.querySelectorAll('[data-gallery-direction]').forEach((button) => button.addEventListener('click', () => setActiveMedia(activeIndex + Number(button.dataset.galleryDirection))));
    if (track) {
      let scrollFrame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => setActiveMedia(Math.round(track.scrollLeft / track.clientWidth), false));
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        setActiveMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    const dialog = section.querySelector('.size-guide');
    const opener = section.querySelector('[data-size-guide-open]');
    opener?.addEventListener('click', () => { dialog?.showModal(); dialog?.querySelector('[data-size-guide-close]')?.focus(); });
    dialog?.addEventListener('close', () => opener?.focus());
    dialog?.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const items = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(item => item.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    section.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    dialog?.querySelectorAll('[data-size-unit]').forEach(button => button.addEventListener('click', () => {
      const unit = button.dataset.sizeUnit;
      dialog.querySelectorAll('[data-size-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      dialog.querySelectorAll('[data-size-cm]').forEach(cell => { cell.textContent = unit === 'in' ? (Number(cell.dataset.sizeCm) / 2.54).toFixed(1) : cell.dataset.sizeCm; });
      dialog.querySelectorAll('[data-size-unit-label]').forEach(label => { label.textContent = button.textContent; });
    }));
    const bootsDialog = section.querySelector('[data-boots-guide]');
    const bootsOpener = section.querySelector('[data-boots-guide-open]');
    bootsOpener?.addEventListener('click', () => { bootsDialog?.showModal(); bootsDialog?.querySelector('[data-boots-guide-close]')?.focus(); });
    bootsDialog?.addEventListener('close', () => bootsOpener?.focus());
    bootsDialog?.querySelector('[data-boots-guide-close]')?.addEventListener('click', () => bootsDialog.close());
    bootsDialog?.addEventListener('click', event => {
      const bounds = bootsDialog.getBoundingClientRect();
      if (event.target === bootsDialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) bootsDialog.close();
    });
    bootsDialog?.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const items = Array.from(bootsDialog.querySelectorAll('button:not([disabled]), a[href], select:not([disabled])')).filter(item => item.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    const dataElement = section.querySelector('[data-product-data]');
    if (!dataElement) {
      section.dataset.enhanced = 'true';
      return;
    }
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch { return; }
    if (!Array.isArray(data.variants) || !data.strings) return;
    section.dataset.enhanced = 'true';
    const form = section.querySelector('[data-product-form]');
    const select = section.querySelector('[data-variant-select]');
    const options = Array.from(section.querySelectorAll('[data-option-index]'));
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const discount = section.querySelector('[data-product-discount]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const submit = section.querySelector('[data-add-button]');
    const submitText = section.querySelector('[data-add-text]');
    const quantity = section.querySelector('[data-quantity]');
    const status = section.querySelector('[data-product-status]');
    const error = section.querySelector('[data-product-error]');
    const addPrice = section.querySelector('[data-add-price]');
    const bootsToggle = section.querySelector('[data-boots-toggle]');
    const bootsSelect = section.querySelector('[data-boots-variant]');
    bootsToggle?.addEventListener('change', () => {
      bootsSelect.required = bootsToggle.checked;
      updateAddPrice();
      if (bootsToggle.checked) bootsSelect.focus();
    });
    bootsSelect?.addEventListener('change', () => {
      const bootsPrice = section.querySelector('[data-boots-price]');
      if (bootsPrice && bootsSelect.selectedOptions[0]?.dataset.price) bootsPrice.innerHTML = bootsSelect.selectedOptions[0].dataset.price;
      updateAddPrice();
    });
    const tierCards = Array.from(section.querySelectorAll('[data-bundle-card]'));
    const tiers = Array.isArray(data.tiers) ? data.tiers : [];
    const colorLinks = Array.from(section.querySelectorAll('[data-product-color]'));
    const hasBundles = tiers.length === 3 && tiers.every((tier) => tier.variants.length);
    const initialVariant = data.variants.find((variant) => String(variant.id) === String(select.value));
    let selectedVariant = initialVariant;
    let selectedTier = hasBundles ? tiers[0] : null;
    let busy = false;
    const updateAddPrice = () => {
      if (!addPrice || !selectedVariant) return;
      if (!bootsToggle?.checked) {
        addPrice.innerHTML = selectedVariant.price;
        return;
      }
      const bootsCents = Number(bootsSelect?.selectedOptions[0]?.dataset.priceCents || bootsToggle.dataset.defaultPriceCents || 0);
      const total = Number(selectedVariant.priceCents) + bootsCents;
      if (!Number.isFinite(total)) return;
      const currency = data.currency || 'USD';
      addPrice.textContent = new Intl.NumberFormat(data.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency, currencyDisplay: currency === 'USD' ? 'narrowSymbol' : 'symbol'
      }).format(total / 100);
    };
    const rememberedSizes = Array(3).fill(initialVariant?.options[0]);
    const colorProducts = Array.isArray(data.colorProducts) ? data.colorProducts : [];
    const hasColorChoices = colorProducts.length > 0 && Boolean(section.querySelector('[data-bundle-color]'));
    const initialColor = colorProducts.find(item => item.color.toLowerCase() === data.selectedColor)?.color || colorProducts[0]?.color;
    const rememberedColors = Array(3).fill(initialColor);
    const requestedColors = new URL(window.location.href).searchParams.get('colors')?.split(',') || [];
    requestedColors.slice(0, 3).forEach((value, index) => {
      const choice = colorProducts.find(item => item.color.toLowerCase() === value.toLowerCase());
      if (choice) rememberedColors[index] = choice.color;
    });
    const requestedSizes = new URL(window.location.href).searchParams.get('sizes')?.split(',') || [];
    requestedSizes.slice(0, 3).forEach((value, index) => {
      if (data.variants.some((variant) => variant.options[0] === value)) rememberedSizes[index] = value;
    });
    const updateColorLinks = () => {
      const currentUrl = new URL(window.location.href);
      colorLinks.forEach((link) => {
        const targetUrl = new URL(link.dataset.colorUrl, window.location.origin);
        targetUrl.searchParams.set('bundle', selectedTier?.count || 1);
        targetUrl.searchParams.set('sizes', rememberedSizes.join(','));
        if (currentUrl.searchParams.has('preview_theme_id')) targetUrl.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
        link.href = targetUrl.href;
      });
    };
    colorLinks.forEach((link) => link.addEventListener('click', (event) => {
      if (busy) event.preventDefault();
    }));
    const selectedOptions = () => options.map((option) => option.querySelector('input:checked')?.value);
    const activeCard = () => tierCards.find((card) => Number(card.dataset.bundleCard) === selectedTier?.count);
    const selectedCoats = () => Array.from(activeCard()?.querySelectorAll('[data-bundle-option]') || []).map((input, index) => {
      const color = activeCard().querySelector(`[data-bundle-color="${index}"]`)?.value;
      return colorProducts.find(item => item.color === color)?.variants.find(variant => variant.size === input.value);
    });
    const updateCoatChoices = () => {
      if (!hasColorChoices) return;
      const card = activeCard();
      card?.querySelectorAll('[data-bundle-option]').forEach((input, index) => {
        const color = card.querySelector(`[data-bundle-color="${index}"]`)?.value;
        const product = colorProducts.find(item => item.color === color);
        Array.from(input.options).forEach(option => {
          const available = Boolean(product?.variants.find(variant => variant.size === option.value)?.available);
          option.textContent = available ? option.value : `${option.value} — ${data.strings.soldOut}`;
        });
      });
      const coats = selectedCoats();
      const available = coats.length === selectedTier?.count && coats.every(coat => coat?.available);
      submit.disabled = busy || !available;
      submitText.textContent = busy ? data.strings.adding : available ? data.strings.add : data.strings.soldOut;
      status.textContent = available ? '' : data.strings.soldOutDetail;
    };
    const matchSizes = (variants, values) => {
      const exact = variants.find(candidate => candidate.options.every((value, index) => value === values[index]));
      if (exact) return exact;
      const key = values.slice().sort().join('|');
      return variants.find(candidate => candidate.options.slice().sort().join('|') === key);
    };
    const updateVariant = (variant, updateUrl = true, chosenSizes = null) => {
      selectedVariant = variant;
      if (variant && !Array.from(select.options).some((option) => option.value === String(variant.id))) {
        select.querySelector('[data-bundle-variant]')?.remove();
        const bundleOption = new Option(`${selectedTier.name} — ${variant.options.join(' / ')}`, String(variant.id));
        bundleOption.dataset.bundleVariant = 'true';
        select.add(bundleOption);
      }
      select.value = variant ? String(variant.id) : '';
      submit.disabled = busy || !variant?.available;
      submitText.textContent = busy ? data.strings.adding : variant ? (variant.available ? data.strings.add : data.strings.soldOut) : data.strings.unavailable;
      status.textContent = variant ? (variant.available ? '' : selectedTier?.count > 1 ? data.strings.bundleSoldOut : data.strings.soldOutDetail) : data.strings.unavailableDetail;
      error.hidden = true;
      if (variant) {
        price.innerHTML = variant.price;
        stickyPrice.innerHTML = variant.price;
        compare.innerHTML = variant.compare || '';
        compare.hidden = !variant.compare;
        if (discount) {
          discount.textContent = variant.discount || '';
          discount.hidden = !variant.discount;
        }
        if (addPrice) {
          addPrice.hidden = !hasBundles;
          updateAddPrice();
        }
        quantity.min = hasBundles ? 1 : variant.quantityMin || 1;
        quantity.step = hasBundles ? 1 : variant.quantityStep || 1;
        if (hasBundles) {
          quantity.max = 1;
          quantity.value = 1;
        } else {
          if (variant.quantityMax != null) quantity.max = variant.quantityMax;
          else quantity.removeAttribute('max');
          const minimum = Number(quantity.min);
          const step = Number(quantity.step);
          let value = Math.max(minimum, Number(quantity.value) || minimum);
          value = minimum + Math.ceil((value - minimum) / step) * step;
          if (quantity.max) value = Math.min(Number(quantity.max), value);
          quantity.value = value;
        }
        if (!hasBundles || selectedTier.count === 1) {
          options.forEach((option, index) => {
            option.querySelectorAll('input').forEach((input) => { input.checked = input.value === variant.options[index]; });
          });
        }
        if (hasBundles) {
          activeCard()?.querySelectorAll('[data-bundle-option]').forEach((input, index) => {
            input.value = chosenSizes?.[index] || variant.options[index];
            rememberedSizes[index] = input.value;
          });
          const cardPrice = activeCard()?.querySelector('[data-bundle-price]');
          if (cardPrice) cardPrice.innerHTML = variant.price;
          const cardCompare = activeCard()?.querySelector('[data-bundle-compare]');
          if (cardCompare) {
            cardCompare.innerHTML = variant.compare || '';
            cardCompare.hidden = !variant.compare;
          }
          const cardUnit = activeCard()?.querySelector('[data-bundle-unit]');
          if (cardUnit && variant.unitPrice) cardUnit.innerHTML = variant.unitPrice;
          const cardSaving = activeCard()?.querySelector('[data-bundle-saving]');
          if (cardSaving) { cardSaving.innerHTML = variant.saving || ''; cardSaving.hidden = !variant.saving; }
          const cardDiscount = activeCard()?.querySelector('[data-bundle-discount]');
          if (cardDiscount) {
            cardDiscount.textContent = variant.discount || '';
            cardDiscount.hidden = !variant.discount;
          }
        }
        if (variant.mediaId) {
          const index = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(variant.mediaId));
          if (index >= 0) setActiveMedia(index);
        }
      } else {
        price.textContent = data.strings.unavailable;
        stickyPrice.textContent = data.strings.unavailable;
        compare.hidden = true;
        if (discount) discount.hidden = true;
        if (addPrice) addPrice.hidden = true;
      }
      options.forEach((option, index) => {
        const selected = selectedOptions();
        option.querySelector('[data-selected-option]').textContent = selected[index] || '';
        option.querySelectorAll('input').forEach((input) => {
          const available = data.variants.some((candidate) => candidate.available && candidate.options.every((value, candidateIndex) => value === (candidateIndex === index ? input.value : selected[candidateIndex])));
          input.closest('label').dataset.unavailable = String(!available);
        });
      });
      if (hasBundles) {
        const card = activeCard();
        const selected = Array.from(card.querySelectorAll('[data-bundle-option]')).map((input) => input.value);
        card.querySelectorAll('[data-bundle-option]').forEach((input, index) => {
          Array.from(input.options).forEach((option) => {
            const proposed = selected.map((value, candidateIndex) => candidateIndex === index ? option.value : value);
            const available = Boolean(matchSizes(selectedTier.variants, proposed)?.available);
            option.textContent = available ? option.value : `${option.value} — ${data.strings.soldOut}`;
          });
        });
      }
      updateColorLinks();
      updateCoatChoices();
      if (updateUrl && section.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        if (hasBundles && selectedTier.count > 1) {
          url.searchParams.set('bundle', selectedTier.count);
          if (variant) url.searchParams.set('bundle_variant', variant.id);
          else url.searchParams.delete('bundle_variant');
          const single = data.variants.find((candidate) => candidate.options[0] === rememberedSizes[0]);
          if (single) url.searchParams.set('variant', single.id);
        } else {
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          if (hasBundles) url.searchParams.set('bundle', '1');
          url.searchParams.delete('bundle_variant');
        }
        if (colorLinks.length > 1 || hasColorChoices) url.searchParams.set('sizes', rememberedSizes.join(','));
        if (hasColorChoices) url.searchParams.set('colors', rememberedColors.join(','));
        window.history.replaceState({}, '', url);
      }
    };
    const chooseTier = (count, variantId, updateUrl = true) => {
      selectedTier = tiers.find((tier) => tier.count === count) || tiers[0];
      tierCards.forEach((card) => {
        const selected = Number(card.dataset.bundleCard) === selectedTier.count;
        card.classList.toggle('is-selected', selected);
        card.querySelector('[data-bundle-choice]').checked = selected;
        card.querySelector('[data-bundle-details]').hidden = !selected;
        card.querySelectorAll('[data-bundle-option]').forEach((input, index) => {
          input.disabled = !selected;
          if (selected && rememberedSizes[index] && Array.from(input.options).some((option) => option.value === rememberedSizes[index])) input.value = rememberedSizes[index];
        });
        card.querySelectorAll('[data-bundle-color]').forEach((input, index) => {
          input.disabled = !selected;
          if (selected && rememberedColors[index]) input.value = rememberedColors[index];
        });
      });
      const values = Array.from(activeCard().querySelectorAll('[data-bundle-option]')).map((input) => input.value);
      const explicitVariant = requestedSizes.length ? null : selectedTier.variants.find((candidate) => String(candidate.id) === String(variantId));
      const variant = explicitVariant || matchSizes(selectedTier.variants, values);
      const chosen = explicitVariant ? explicitVariant.options : values;
      updateVariant(variant, updateUrl, chosen);
    };
    options.forEach((option) => option.addEventListener('change', () => {
      const selection = selectedOptions();
      updateVariant(data.variants.find((variant) => variant.options.every((value, index) => value === selection[index])));
    }));
    select.addEventListener('change', () => updateVariant(data.variants.find((variant) => String(variant.id) === select.value)));
    if (hasBundles) {
      section.dataset.bundles = 'true';
      section.querySelector('[data-single-options]')?.setAttribute('hidden', '');
      quantity.closest('.product-quantity').hidden = true;
      section.querySelectorAll('[data-bundle-choice]').forEach((radio) => radio.addEventListener('change', () => chooseTier(Number(radio.value))));
      section.querySelectorAll('[data-bundle-option]').forEach((input) => input.addEventListener('change', () => {
        const values = Array.from(activeCard().querySelectorAll('[data-bundle-option]')).map((option) => option.value);
        values.forEach((value, index) => { rememberedSizes[index] = value; });
        updateVariant(matchSizes(selectedTier.variants, values), true, values);
      }));
      section.querySelectorAll('[data-bundle-color]').forEach(input => input.addEventListener('change', () => {
        const index = Number(input.dataset.bundleColor);
        rememberedColors[index] = input.value;
        const values = Array.from(activeCard().querySelectorAll('[data-bundle-option]')).map(option => option.value);
        updateVariant(matchSizes(selectedTier.variants, values), true, values);
        const product = colorProducts.find(item => item.color === input.value);
        const mediaIndex = slides.findIndex(slide => String(slide.dataset.mediaId) === String(product?.mediaId));
        if (mediaIndex >= 0) setActiveMedia(mediaIndex);
      }));
      const url = new URL(window.location.href);
      const directTier = tiers.find((tier) => new URL(tier.url, window.location.origin).pathname === url.pathname);
      const count = Number(url.searchParams.get('bundle')) || (directTier?.count > 1 ? directTier.count : 1);
      const variantId = url.searchParams.get('bundle_variant') || (directTier?.count > 1 ? url.searchParams.get('variant') : count === 1 && !requestedSizes.length ? initialVariant?.id : null);
      chooseTier(count, variantId, false);
    }
    section.querySelectorAll('[data-quantity-direction]').forEach((button) => button.addEventListener('click', () => {
      const minimum = Number(quantity.min) || 1;
      const step = Number(quantity.step) || 1;
      let value = Math.max(minimum, (Number(quantity.value) || minimum) + Number(button.dataset.quantityDirection) * step);
      if (quantity.max) value = Math.min(Number(quantity.max), value);
      quantity.value = value;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || !selectedVariant || !(hasColorChoices ? selectedCoats().every(coat => coat?.available) : selectedVariant.available) || !form.reportValidity()) return;
      busy = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitText.textContent = data.strings.adding;
      error.hidden = true;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 30000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const headers = { Accept: 'application/json' };
        let body = new FormData(form);
        if (hasColorChoices || (bootsToggle?.checked && bootsSelect?.value)) {
          headers['Content-Type'] = 'application/json';
          const items = hasColorChoices ? selectedCoats().map(coat => ({ id: Number(coat.id), quantity: 1 })) : [{ id: Number(selectedVariant.id), quantity: Number(quantity.value) || 1 }];
          if (bootsToggle?.checked && bootsSelect?.value) items.push({ id: Number(bootsSelect.value), quantity: 1 });
          const merged = Array.from(items.reduce((map, item) => {
            const existing = map.get(item.id);
            map.set(item.id, { id: item.id, quantity: item.quantity + (existing?.quantity || 0) });
            return map;
          }, new Map()).values());
          body = JSON.stringify({ items: merged });
        }
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers, body, signal: controller.signal });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || data.strings.error);
        window.location.assign(section.dataset.cartUrl || `${root}cart`);
      } catch (failure) {
        error.textContent = controller.signal.aborted ? data.strings.timeout : failure instanceof Error && failure.message !== 'Failed to fetch' ? failure.message : data.strings.error;
        error.hidden = false;
        busy = false;
        submit.disabled = !selectedVariant?.available;
        submit.removeAttribute('aria-busy');
        submitText.textContent = selectedVariant?.available ? data.strings.add : data.strings.soldOut;
        updateCoatChoices();
      } finally {
        window.clearTimeout(timeout);
      }
    });
    if (!hasBundles) updateVariant(selectedVariant, false);
    const sticky = section.querySelector('[data-product-sticky]');
    sticky?.querySelector('a')?.addEventListener('click', event => {
      event.preventDefault();
      const target = section.querySelector('.product-info');
      window.scrollTo({ top: window.scrollY + target.getBoundingClientRect().top - 24, behavior: 'instant' });
    });
    if (sticky && 'IntersectionObserver' in window) {
      const updateSticky = () => { sticky.hidden = form.getBoundingClientRect().bottom >= 0; };
      const observer = new IntersectionObserver(updateSticky, { threshold: 0 });
      let frame;
      const onScroll = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(updateSticky); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateSticky();
      observer.observe(form);
      document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(section)) observer.disconnect(); }, { once: true });
    }
  };
  const initializeAll = (root = document) => root.querySelectorAll('[data-st-puffer-section]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
